import { Link } from 'react-router-dom'
import Card from '@/components/ui/Card'
import Illustration from '@/components/Illustration'

const programs = [
  {
    id: 'sponsor-classroom',
    title: 'Sponsor a Classroom',
    blurb: 'Fund supplies, field trips, and hands-on learning.',
    donateTo: '/sponsor-classroom/donate',
    aboutTo: '/programs/sponsor-classroom/about',
    illustration: 'books',
    comingSoon: false,
  },
  {
    id: 'rent-assistance',
    title: 'Rent Assistance',
    blurb: 'Emergency assistance so families can stay housed.',
    donateTo: '/rent-assistance/donate',
    aboutTo: '/programs/rent-assistance/about',
    illustration: 'leaf',
    comingSoon: true,
  },
  {
    id: 'tower-smbs',
    title: 'Tower for SMBs',
    blurb: 'Sponsor local classrooms as part of your community impact.',
    donateTo: '/tower-smbs/donate',
    aboutTo: '/programs/tower-smbs/about',
    illustration: 'teacher',
    comingSoon: true,
  },
  {
    id: 'sponsor-athlete',
    title: 'Sponsor an Athlete (Prospect)',
    blurb: 'Back youth athletics with equipment, fees, and travel.',
    donateTo: '/sponsor-athlete/donate',
    aboutTo: '/programs/sponsor-athlete/about',
    illustration: 'kids',
    comingSoon: true,
  },
]

export default function Programs() {
  return (
    <div className="space-y-10">
      <header className="space-y-2">
        <h1 className="text-3xl font-semibold text-cocoa">Our Programs</h1>
        <p className="text-cocoa/70">
          Choose an area to donate openly or log in if you already have access.
        </p>
        <nav className="flex flex-wrap gap-2 pt-2">
          <Link className="btn border border-sand bg-white text-cocoa hover:bg-shell" to="/nominate">
            Nominate
          </Link>
        </nav>
      </header>

      <div className="grid gap-6 md:grid-cols-2">
        {programs.map(program => (
          <Card key={program.id} className="relative overflow-hidden">
            <div className="flex items-start gap-4">
              <Illustration name={program.illustration} className="h-16 w-16 flex-shrink-0" animate />
              <div className="space-y-3">
                <div className="space-y-2">
                  <div className="flex flex-wrap items-center gap-3">
                    <h2 className="text-xl font-semibold text-cocoa">{program.title}</h2>
                    {program.comingSoon ? (
                      <span className="rounded-full bg-shell px-2.5 py-1 text-xs font-semibold uppercase tracking-wide text-cocoa/70">
                        Coming soon
                      </span>
                    ) : null}
                  </div>
                  <p className="text-sm text-cocoa/80">{program.blurb}</p>
                </div>

                <div className="flex flex-wrap gap-2 pt-1">
                  {program.aboutTo ? (
                    <Link className="btn bg-white text-cocoa border border-sand hover:bg-shell" to={program.aboutTo}>
                      About
                    </Link>
                  ) : null}
                  {program.id === 'sponsor-classroom' ? (
                    <>
                      {program.donateTo ? (
                        <Link className="btn" to={program.donateTo}>
                          Open Donations
                        </Link>
                      ) : null}
                      <Link className="btn bg-mint text-cocoa hover:bg-mint/80" to="/login?role=sponsor">
                        Sponsor Login
                      </Link>
                      <Link className="btn border border-sand bg-white text-cocoa hover:bg-shell" to="/login?role=teacher">
                        Teacher Login
                      </Link>
                    </>
                  ) : null}
                </div>
              </div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  )
}
